import plans from "_shared/constants/plans";
import { formatDate } from "_shared/helpers/formatting";
import { useSubscriptionsContext } from "account/manageSubscriptions/contexts/SubscriptionsContext";
import { useTickersContext } from "account/manageSubscriptions/contexts/TickersContext";
import clsx from "clsx";
import { addMonths } from "date-fns";
import styles from "./PlanSelection.module.scss";
import PlanSlider from "./PlanSlider";

function PlanSelection() {
  const {
    billingDate,
    selectedPlanIndex,
    currentPlanIndex,
    setSelectedPlanIndex,
    expiringPlanIndex,
    planChange,
    reactivatePlan,
  } = useSubscriptionsContext();
  const { tickerCount, openTickerModal } = useTickersContext();
  const plan = plans[selectedPlanIndex];
  const awaitingDowngrade =
    (expiringPlanIndex !== undefined &&
      expiringPlanIndex > selectedPlanIndex) ||
    planChange === "downgrade";
  const awaitingCancelation =
    currentPlanIndex === undefined && selectedPlanIndex === undefined;
  return (
    <div className={styles.container}>
      {currentPlanIndex < 0 ? (
        <button className={styles.reactivateButton} onClick={reactivatePlan}>
          Reactivate your plan
        </button>
      ) : (
        <>
          <div
            className={clsx(
              styles.planMessage,
              awaitingDowngrade && styles.danger,
            )}
          >
            Your plan will{" "}
            <span className={styles.highlight}>
              {awaitingCancelation
                ? "be cancelled"
                : awaitingDowngrade
                ? "downgrade"
                : "renew"}
            </span>{" "}
            on{" "}
            {billingDate && currentPlanIndex !== 0 ? (
              <span className={styles.highlight}>
                {formatDate(billingDate)}
              </span>
            ) : (
              <span className={styles.highlight}>
                {formatDate(addMonths(new Date(), 1))}
              </span>
            )}
          </div>
          <PlanSlider
            value={selectedPlanIndex}
            onChange={setSelectedPlanIndex}
            expiringPlan={expiringPlanIndex}
          />
          <div className={styles.textContent}>
            <h3 className={styles.currentPlan}>{plan.name} Plan</h3>
            <div
              className={clsx(
                styles.tickerCount,
                tickerCount > plan.tickerLimit && styles.danger,
              )}
            >
              You are using{" "}
              <span className={styles.highlight}>
                {tickerCount} of {plan.tickerLimit}
              </span>{" "}
              tickers
            </div>
            <div className={styles.planPrice}>${plan.priceMonthly} / month</div>
          </div>
          <button className={styles.tickerButton} onClick={openTickerModal}>
            Ticker List
          </button>
        </>
      )}
    </div>
  );
}

export default PlanSelection;
